import axios from 'axios'
import { setIn } from 'formik'
import { useEffect, useState } from 'react'

import img1 from '../../assets/images/img-01.jpg'
import img2 from '../../assets/images/img-02.jpg'

import PageBanner from '../../shared/components/pageBanner/pageBanner'

import './aboutPage.css'

import Backdrop from '@mui/material/Backdrop';
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";

const AboutPage = () => {

	const [info, setInfo] = useState();
	const [open, setOpen] = useState(true);

	useEffect(() => {
		window.scrollTo(0, 0)
		fetchData();
	}, [])

	useEffect(() => {
		if (info)
			setOpen(false);
	}, [info])

	const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

	const fetchData = async () => {
		const response = await axios.request({
			method: 'get',
			url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/get-about-us-page-info`
		})
		setInfo(response.data[0]);
	}

	console.log("About-us-info: ", info);
	return (
		<div className="wrapper">
			<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={open}>
				<SyncLoader color={"#ff7e06"} loading={true} css={override} size={11} />
			</Backdrop>
			<PageBanner check={false} title="About us" content={info && info.subTitle} />
			<div className="about-block">
				<div className="container text-center">
					<h2 className="mb-3">About Livestock</h2>
					<p>{info && info.description}</p>
				</div>
			</div>
			<div className="mission-block">
				<div className="container">
					<div className="row align-items-md-center flex-row-reverse flex-md-row">
						<div className="col-md-4 pt-2 text-center">
							<div className="image-holder">
								<img alt="" className="img-fluid" src={img1} />
							</div>
						</div>
						<div className="col-md-4 pt-2 text-center">
							<div className="image-holder">
								<img alt="" className="img-fluid" src={img2} />
							</div>
						</div>
						<div className="col-md-4">
							<div className="d-flex flex-column">
								<h2 className="mb-3">Our mission</h2>
								<p>{info && info.mission}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="buy-sell-policy">
				<div className="container">
					<div className="heading-block mb-5 text-center">
						<h2 className="mb-3">The Website</h2>
						<p>{info && info.websiteDesc}</p>
					</div>
					<div className="row">
						{info && info.toolBox.map((tool, key) => {
							return (
								<div className="col-md-6 pt-2" key={key}>
									<div className="policy-block">
										<h3 className="text-white">{tool.title}</h3>
										<ul className="policy-points list-unstyled">
											{tool.points.map((point, key) => <li className="mb-1 position-relative" key={key}>{point}</li>)}
										</ul>
									</div>
								</div>
							)
						})}
					</div>
				</div>
			</div>
		</div>
	)
}

export default AboutPage
